/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Swift_Warm_Bear_LeapInputs */

const en_swift_warm_bear_leap = /** @type {(inputs: Swift_Warm_Bear_LeapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`V2 (Recommended)`)
};

const de_swift_warm_bear_leap = /** @type {(inputs: Swift_Warm_Bear_LeapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`V2 (Empfohlen)`)
};

/**
* | output |
* | --- |
* | "V2 (Recommended)" |
*
* @param {Swift_Warm_Bear_LeapInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const swift_warm_bear_leap = /** @type {((inputs?: Swift_Warm_Bear_LeapInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Swift_Warm_Bear_LeapInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_swift_warm_bear_leap(inputs)
	return de_swift_warm_bear_leap(inputs)
});